import { Loading } from "components/Loading/loading";
import { Message } from "components/Message/Message";
import { TableTree } from "components/TableTree/TableTree";
import { useEffect, useState } from "react";
import { getDynamicForm, JobEntireTree } from "./api/api";
import { ModalStepper } from "components/ModalStepper/ModalStepper";
import { ModalForm } from "components/ModalForm/ModalForm";
import { ActionsOfReference } from "pages/AfterSales/component/RefrenceHistory/ActionsOfReference";
import { JobActions } from "pages/OfficeAutomation/Cartable/components/ActionList/components/JobActions/JobActions";
interface ReferenceHistoryPropsType {
  jobId: any;
  rowObject?: any;
}

export const ReferenceHistory = ({
  jobId,
  rowObject,
}: ReferenceHistoryPropsType) => {
  const [response, setResponse] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [messageType, setMessageType] = useState<any>("info");
  const [dynamicForm, setDynamicForm] = useState<any>("");
  let [showDynamicForm, setShowDynamicForm] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>();
  const [ShowDynamicFormViewLoading, setShowDynamicFormViewLoading] =
    useState(false);
  async function getDynamicFormAsync(id: string) {
    setShowDynamicFormViewLoading(false);
    try {
      const res = await getDynamicForm(id);
      if (res.Data) {
        let data: any = [];
        res.Data.map((item, index) => {
          if (item.Name != "SignatureForm") {
            if (
              res.Data?.[index + 1] &&
              res.Data?.[index + 1]?.Name == "SignatureForm"
            ) {
              data.push({ ...item, forms: [res.Data[index + 1]] });
            } else {
              data.push(item);
            }
          }
        });
        setDynamicForm(data);
      } else setDynamicForm(undefined);
      if (dynamicForm) {
      }
    } catch (error) {
      setMessageType("error");
    }
    setShowDynamicFormViewLoading(true);
  }

  async function jobEntireTreeAsync(jobId) {
    setLoading(false);
    try {
      const res = await JobEntireTree(jobId);
      setResponse(res.Data);
    } catch (error) {
      setResponse([]);
      setMessageType("error");
    }
    setLoading(true);
  }

  useEffect(() => {
    jobEntireTreeAsync(jobId);
  }, [jobId]);

  useEffect(() => {
    if (showDynamicForm) {
      getDynamicFormAsync(selectedRow.Id);
    }
  }, [showDynamicForm]);

  return (
    <>
      <div className=" mx-4">
        {loading ? (
          response ? (
            <TableTree
              italic={"Reversed"}
              params={"Id"}
              Data={[response]}
              theadData={Object.keys(response)}
              parentName={"JobReferenceHistory"}
              startIndex={4}
              Childrenparams={"ReferenceList"}
              DoubleClick={(e) => {
                setSelectedRow(e);
                setShowDynamicForm(true);
              }}
              defultShow={true}
            />
          ) : (
            <Message message={"NoDataForPreview"} type={messageType} />
          )
        ) : (
          <Loading />
        )}
        <JobActions jobId={jobId} referenceId={rowObject?.ReferenceId} />
        {showDynamicForm && (
          <ModalForm
            mode={"edit"}
            title={"Actions"}
            onHide={() => {
              setShowDynamicForm(false);
            }}
            show={showDynamicForm}
          >
            {ShowDynamicFormViewLoading ? (
              <>
                {showDynamicForm &&
                  (dynamicForm ? (
                    <ModalStepper
                      inDynamicForms={true}
                      jobId={jobId}
                      onHide={() => {
                        setShowDynamicForm(false);
                      }}
                      refrenceId={selectedRow?.Id}
                      useGenerate={false}
                      Id={selectedRow?.Id}
                      taskTitle={selectedRow?.TaskTitle}
                      formList={dynamicForm}
                      parentMode={"view"}
                    />
                  ) : (
                    <Message message={"NoFormForPreview"} type={messageType} />
                  ))}
              </>
            ) : (
              <Loading />
            )}
            <ActionsOfReference referenceId={selectedRow?.Id} />
          </ModalForm>
        )}
      </div>
    </>
  );
};
